import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { parsePhoneNumberFromString } from "libphonenumber-js/min";
import * as React from "react";

import { Link, RelodeTheme, Text } from "../";
import { PhoneIcon } from "../../assets/icons";

interface PhoneLinkProps extends WithStyles<typeof styles> {
    id?: string;
    phone: string;
    variant: "textOnly" | "iconOnly" | "textAndIcon";
    className?: string;
    title?: string;
    highlightType?: "external" | "internal";
    hideHighlight?: boolean;
    inline?: boolean;
}

export const formatTelUri = (phone: string) => {
    if (!phone) return "";
    const phoneNumber = parsePhoneNumberFromString("+" + phone);
    return phoneNumber.getURI();
};

const formatPhoneText = (phone: string) => {
    if (!phone) return "";
    const phoneNumber = parsePhoneNumberFromString("+" + phone);
    return phoneNumber.formatNational();
};

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            alignItems: "flex-start",
        },
        text: {
            display: "inline",
        },
        icon: {
            marginRight: theme.spacing(1),
        },
        inline: {
            display: "inline-flex",
        },
    });

// TODO this is intended to replace the PhoneLink component from "../links/phoneLink" once we have time;
export const PhoneLink = withStyles(styles, { name: "PhoneLink" })(
    (props: PhoneLinkProps) => {
        const {
            id = "phoneLink",
            classes,
            className: classNameProp,
            phone,
            variant,
            title = formatPhoneText(props.phone),
            highlightType,
            hideHighlight,
            inline,
            ...passthrough
        } = props;
        const dataCy = passthrough["data-cy"];
        const iconCy = !!dataCy ? `${dataCy}-icon` : undefined;
        const textCy = !!dataCy ? `${dataCy}-text` : undefined;

        const rootClasses = classnames(classes.root, classNameProp, {
            [classes.inline]: inline,
        });

        return (
            <div className={rootClasses}>
                {variant === "iconOnly" || variant === "textAndIcon" ? (
                    <Link
                        href={formatTelUri(phone)}
                        hideHighlight={true}
                        gutterBottom={false}
                        title={title}
                        data-cy={iconCy}
                        id={`${id}-link`}
                    >
                        <PhoneIcon
                            id={`${id}-icon`}
                            className={
                                variant === "textAndIcon" ? classes.icon : ""
                            }
                            color="primary"
                        />
                    </Link>
                ) : null}
                {variant === "textOnly" || variant === "textAndIcon" ? (
                    <Link
                        href={formatTelUri(phone)}
                        highlightType={highlightType}
                        hideHighlight={hideHighlight}
                        title={title}
                        gutterBottom
                        data-cy={textCy}
                        id={`${id}-link`}
                    >
                        <Text
                            variant="body1"
                            className={classes.text}
                            id={`${id}-text`}
                        >
                            {formatPhoneText(props.phone)}
                        </Text>
                    </Link>
                ) : null}
            </div>
        );
    }
);
